import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import PageSkeleton from './components/skeletons/PageSkeleton';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
// Lazy load pages
const Login = lazy(() => import('./pages/Login'));
const Rewards = lazy(() => import('./pages/Rewards'));
const RewardCreate = lazy(() => import('./pages/RewardCreate'));
const RewardDetail = lazy(() => import('./pages/RewardDetail'));
const Claims = lazy(() => import('./pages/Claims'));
const Insights = lazy(() => import('./pages/Insights'));
const Profile = lazy(() => import('./pages/Profile'));
const ProfilePreview = lazy(() => import('./pages/ProfilePreview'));
// Skeleton wrapper component
const SkeletonWrapper = ({
  type
}) => <div className="flex h-screen bg-gray-50" data-id="element-2">
    <div className="w-20 flex-shrink-0" data-id="element-3">
      <Sidebar data-id="element-4" />
    </div>
    <div className="flex-1 flex flex-col overflow-hidden" data-id="element-5">
      <Topbar data-id="element-6" />
      <div className="flex-1 overflow-y-auto" data-id="element-7">
        <PageSkeleton type={type} data-id="element-8" />
      </div>
    </div>
  </div>;
export function AppRouter() {
  // Set page title
  useEffect(() => {
    document.title = 'Greenback Partner';
  }, []);
  return <BrowserRouter data-id="element-9">
      <Suspense fallback={<div className="min-h-screen bg-greenback flex items-center justify-center" data-id="element-11">
            <div className="text-white" data-id="element-12">Caricamento...</div>
          </div>} data-id="element-10">
        <Routes data-id="element-13">
          {/* Login route - default landing page */}
          <Route path="/" element={<Login data-id="element-15" />} data-id="element-14" />
          <Route path="/login" element={<Login data-id="element-17" />} data-id="element-16" />

          {/* Main routes */}
          <Route path="/overview" element={<App data-id="element-19" />} data-id="element-18" />

          {/* Rewards routes */}
          <Route path="/rewards" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-22" />} data-id="element-21">
                <Rewards data-id="element-23" />
              </Suspense>} data-id="element-20" />
          <Route path="/rewards/new" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-26" />} data-id="element-25">
                <RewardCreate data-id="element-27" />
              </Suspense>} data-id="element-24" />
          <Route path="/rewards/:rewardId" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-30" />} data-id="element-29">
                <RewardDetail data-id="element-31" />
              </Suspense>} data-id="element-28" />

          {/* Claims route */}
          <Route path="/claims" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-34" />} data-id="element-33">
                <Claims data-id="element-35" />
              </Suspense>} data-id="element-32" />

          {/* Insights route */}
          <Route path="/insights" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-38" />} data-id="element-37">
                <Insights data-id="element-39" />
              </Suspense>} data-id="element-36" />

          {/* Profile routes */}
          <Route path="/profile" element={<Suspense fallback={<SkeletonWrapper type="dashboard" data-id="element-42" />} data-id="element-41">
                <Profile data-id="element-43" />
              </Suspense>} data-id="element-40" />
          <Route path="/profile/preview" element={<Suspense fallback={<div className="min-h-screen bg-gray-50 flex items-center justify-center" data-id="element-46">
                    <div className="text-gray-500" data-id="element-47">Caricamento...</div>
                  </div>} data-id="element-45">
                <ProfilePreview data-id="element-48" />
              </Suspense>} data-id="element-44" />

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-50" />} data-id="element-49" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}